module.exports = __webpack_public_path__ + "img/iso.90bd71ac.svg";